import { render, staticRenderFns } from "./CertificationsTabInvoices.vue?vue&type=template&id=4e1a4cd8&"
import script from "./CertificationsTabInvoices.vue?vue&type=script&lang=js&"
export * from "./CertificationsTabInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports